import { ReactComponent as CheckmarkIcon } from "../../assets/icons/outline/icon_checkmark_outline.svg";
import { ReactComponent as BodyMap } from "../../assets/images/bodymap-back.svg";
import { useState } from "react";
import { Option } from "../../models/interfaces/option";

const COMPONENT_CLASS = "c-back-pain-areas-tab";

export interface BackPainAreasTabProps {
    options: Option[];
    onChange: (option: Option, checked: boolean) => void;
}
const BackPainAreasTab: React.FC<BackPainAreasTabProps> = ({
    options,
    onChange,
}) => {
    const [visibleLabels, setVisibleLabels] = useState<{ [key: string]: boolean }>({});

    const handleButtonClick = (option: Option) => {
        onChange(option, !option.isSelected);

        // Show label briefly
        setVisibleLabels((prev) => ({ ...prev, [option.value]: true }));
        setTimeout(
            () => setVisibleLabels((prev) => ({ ...prev, [option.value]: false })),
            2000
        );
    };
    return (
        <div className={COMPONENT_CLASS}>
            <div className={`${COMPONENT_CLASS}__body-map`}>
                <BodyMap className={`${COMPONENT_CLASS}__image`} />

                <div className={`${COMPONENT_CLASS}__absolute-overlay`}>
                    {options.map((option, index) => {
                        const sideClass =
                            option.labelSide === "left"
                                ? `${COMPONENT_CLASS}__label-container--left`
                                : `${COMPONENT_CLASS}__label-container--right`;
                        const size = option.size ?? 38;
                        return (
                            <div
                                key={index}
                                className={`${COMPONENT_CLASS}__button-container`}
                                style={{
                                    top: option.top ?? "0px",
                                    left: option.left ?? "0px",
                                    zIndex: option.zIndex ?? 1,

                                }}
                            >
                                <button
                                    className={`${COMPONENT_CLASS}__pain-button ${option.isSelected ? "selected" : ""
                                        }`}
                                    aria-pressed={option.isSelected}
                                    onClick={() => handleButtonClick(option)}
                                    style={{
                                        width: `${size}px`,
                                        height: `${size}px`,
                                        zIndex: option.zIndex ?? 2,
                                    }}
                                >
                                    {option.isSelected && <CheckmarkIcon />}
                                </button>

                                <div
                                    className={`${COMPONENT_CLASS}__label-container ${sideClass} ${visibleLabels[option.value] ? "visible" : ""
                                        }`}
                                    style={
                                        {
                                            minHeight: `${size}px`,
                                            maxHeight: `${size}px`,
                                            // expose the dynamic gap to CSS:
                                            // TypeScript tip: cast to CSSProperties so custom prop is allowed
                                            ['--gap' as any]: `${size}px`,
                                            zIndex: option.zIndex ?? 1,
                                        } as React.CSSProperties
                                    }
                                    data-small={size < 30 ? "true" : "false"}
                                >
                                    <span>{option.label}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default BackPainAreasTab;
